import React from 'react';
import Sidebar from '../../components/sidebar/sidebar';

{/* <Sidebar /> */}

const Dashboard = () => {
  return (
    <div className="dashboard">
        
    <Sidebar />
      <h1>Welcome to the Dashboard</h1>
      <p>This is the landing page after a successful login.</p>
    </div>
  );
};

export default Dashboard;
